'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { LocalAlert } from '@navikt/ds-react';
import styles from './FeilSnackbar.module.css';
interface Props {
  vis: boolean;
  tittel: string;
  onLukk: () => void;
  varighetMs?: number;
}

/** Kortvarig feilmelding nederst på siden, i tittel-modus slik at meldingen holdes på én linje. */
export const FeilSnackbar = t0 => {
  const $ = _c(12);
  const {
    vis,
    tittel,
    onLukk,
    varighetMs: t1
  } = t0;
  const varighetMs = t1 === undefined ? 6000 : t1;
  let t2;
  let t3;
  if ($[0] !== onLukk || $[1] !== varighetMs || $[2] !== vis) {
    t2 = () => {
      if (!vis) {
        return;
      }
      const timer = setTimeout(onLukk, varighetMs);
      return () => clearTimeout(timer);
    };
    t3 = [vis, varighetMs, onLukk];
    $[0] = onLukk;
    $[1] = varighetMs;
    $[2] = vis;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  React.useEffect(t2, t3);
  if (!vis) {
    return null;
  }
  let t4;
  if ($[5] !== tittel) {
    t4 = <LocalAlert.Title>{tittel}</LocalAlert.Title>;
    $[5] = tittel;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== onLukk) {
    t5 = <LocalAlert.CloseButton onClick={onLukk} />;
    $[7] = onLukk;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <div className={styles.snackbar}><LocalAlert status="error" role="alert"><LocalAlert.Header>{t4}{t5}</LocalAlert.Header></LocalAlert></div>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
export default FeilSnackbar;